import {
  lxoSpace,
  lxoRadius,
  lxoSurface,
  lxoFont,
  lxoSectionRow,
} from "shared/styles/lxoDashboardTokens"

export const containerStyle = (
  { breakpoints, functions: { pxToRem } },
  { index }
) => ({
  borderRadius: pxToRem(lxoRadius.surface),
  border: lxoSurface.border,
  background: lxoSurface.background,
  boxShadow: lxoSurface.shadow,
  padding: `${pxToRem(lxoSpace.lg)} ${pxToRem(lxoSpace.xl)}`,
  height: "100%",
  display: "flex",
  flexDirection: "column",

  [breakpoints.down(1600)]: {
    borderRadius: pxToRem(lxoRadius.surface),
    padding: `${pxToRem(lxoSpace.lg)} ${pxToRem(lxoSpace.lg)}`,
  },
})

export const headerStyle = (
  { breakpoints, functions: { pxToRem } },
  { index }
) => ({
  color: "#0F172A",
  fontWeight: 700,
  lineHeight: "1.35",
  letterSpacing: "-0.01em",
  marginBottom: pxToRem(lxoSpace.md),
  padding: 0,
  fontSize: `${lxoFont.sectionTitle}px !important`,

  [breakpoints.down(1600)]: {
    fontSize: `${lxoFont.sectionTitle}px !important`,
    marginBottom: pxToRem(lxoSpace.md),
    padding: 0,
  },
})

export const itemStyle = (
  { breakpoints, functions: { pxToRem } },
  { index }
) => ({
  height: pxToRem(lxoSectionRow.height),
  minHeight: pxToRem(lxoSectionRow.height),
  padding: `0 ${pxToRem(lxoSectionRow.paddingX)}`,
  display: "flex",
  alignItems: "center",
  gap: pxToRem(lxoSectionRow.gap),
  cursor: "pointer",
  borderBottom: "1px solid #F1F5F9",
  transition: "background 0.18s ease",

  "&:last-child": {
    borderBottom: "none",
  },

  "&:hover": {
    background: "#F8FBFF",
  },

  [breakpoints.down(1600)]: {
    height: pxToRem(lxoSectionRow.height),
    minHeight: pxToRem(lxoSectionRow.height),
    padding: `0 ${pxToRem(lxoSectionRow.paddingX)}`,
    gap: pxToRem(lxoSectionRow.gap),
  },
})

export const logoStyle = (
  { palette, breakpoints, functions: { pxToRem } },
  { index }
) => ({
  width: pxToRem(lxoSectionRow.iconSize),
  height: pxToRem(lxoSectionRow.iconSize),
  minWidth: pxToRem(lxoSectionRow.iconSize),
  background: "linear-gradient(135deg, #1576BC, #0FA3E0)",
  borderRadius: pxToRem(lxoRadius.control),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  boxShadow: "0 2px 8px rgba(21, 118, 188, 0.2)",

  [breakpoints.down(1600)]: {
    width: pxToRem(lxoSectionRow.iconSize),
    height: pxToRem(lxoSectionRow.iconSize),
    minWidth: pxToRem(lxoSectionRow.iconSize),
  },
})

export const titleStyle = (
  { breakpoints, palette, typography, functions: { pxToRem } },
  { index }
) => ({
  lineHeight: 1.3,
  letterSpacing: "-0.01em",
  marginBottom: 0,
  fontSize: `${lxoFont.rowTitle}px !important`,
  fontWeight: 600,
  color: "#1E293B",

  "@media (max-width:1600px)": {
    fontSize: `${lxoFont.rowTitle}px !important`,
  },
})

export const subTitleStyle = (
  { breakpoints, palette, typography },
  { index }
) => ({
  lineHeight: 1.25,
  marginBottom: 0,
  fontSize: `${lxoFont.rowSubtitle}px !important`,
  fontWeight: 400,
  color: "#94A3B8",
})

export const logoImageStyle = ({ breakpoints, functions: { pxToRem } }) => ({
  display: "block",
  width: pxToRem(18),
  height: pxToRem(18),

  [breakpoints.down(1600)]: {
    width: pxToRem(18),
    height: pxToRem(18),
  },
})
